import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LoadingState {
  loadingGroup: boolean;
  loadingCourse: boolean;
  loadingSemester: boolean;
  loadingCurricularUnit: boolean;
}

const initialState: LoadingState = {
  loadingGroup: false,
  loadingCourse: false,
  loadingSemester: false,
  loadingCurricularUnit: false,
};

export const LoadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    /** @deprecated Use React's useState instead. */
    setLoadingCourse: (state, action: PayloadAction<boolean>) => {
      state.loadingCourse = action.payload;
    },
    /** @deprecated Use React's useState instead. */
    setLoadingSemester: (state, action: PayloadAction<boolean>) => {
      state.loadingSemester = action.payload;
    },
    /** @deprecated Use React's useState instead. */
    setLoadingCurricularUnit: (state, action: PayloadAction<boolean>) => {
      state.loadingCurricularUnit = action.payload;
    },
    /** @deprecated Use React's useState instead. */
    setLoadingGroup: (state, action: PayloadAction<boolean>) => {
      state.loadingGroup = action.payload;
    },
  },
});

/** @deprecated Use React's useState instead. */
export const {
  setLoadingCourse,
  setLoadingSemester,
  setLoadingCurricularUnit,
  setLoadingGroup,
} = LoadingSlice.actions;
export default LoadingSlice.reducer;
